export class BackupPostureControlGroupCondition {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "operator",
            "baseName": "operator",
            "type": "LogicalOperator",
            "format": ""
        },
        {
            "name": "operands",
            "baseName": "operands",
            "type": "Array<BackupPostureControlExpression>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return BackupPostureControlGroupCondition.attributeTypeMap;
    }
    constructor() {
    }
}
